import React, { useEffect, useState } from 'react';
import styles from './Eyecatch.module.css';

function Eyecatch() {
    const dogImgUrl = process.env.REACT_APP_WP_SERVER + '/wp-content/uploads/2025/01/dog2fc.png';

    function test() {
        const section = document.getElementById("services");
        if (section) {
            section.scrollIntoView({ behavior: "smooth" }); // Smooth scrolling
        }
    }

    const [headlineText, setHeadlineText] = useState('');
    const [serviceArea, setServiceArea] = useState('');
    const [subtitle, setSubtitle] = useState('');
    const [servicesBtn, setServicesBtn] = useState('');
    const [scheduleBtn, setScheduleBtn] = useState('');

    useEffect(() => {
        // Fetch content for showcase left
        fetch(process.env.REACT_APP_WP_SERVER + '/wp-json/wp/v2/site_header?slug=headline-text')
          .then(response => response.json())
          .then(data => {
            if (data[0]?.content?.rendered) {
                setHeadlineText(data[0].content.rendered);
            }
          })
          .catch(error => console.error('Error fetching showcase left content:', error));

        // Hours/Service ARea
        fetch(process.env.REACT_APP_WP_SERVER + '/wp-json/wp/v2/site_header?slug=service-area')
            .then(response => response.json())
            .then(data => {
            if (data[0]?.content?.rendered) {
                setServiceArea(data[0].content.rendered);
            }
            })
            .catch(error => console.error('Error fetching header service area content:', error));

        fetch(process.env.REACT_APP_WP_SERVER + '/wp-json/wp/v2/site_header?slug=headline-subtitle')
            .then(response => response.json())
            .then(data => {
            if (data[0]?.content?.rendered) {
                setSubtitle(data[0].content.rendered);
            }
            })
            .catch(error => console.error('Error fetching header subtitle content:', error));

        fetch(process.env.REACT_APP_WP_SERVER + '/wp-json/wp/v2/site_header?slug=nav-item-services')
            .then(response => response.json())
            .then(data => {
              if (data[0]?.content?.rendered) {
                setServicesBtn(data[0].content.rendered);
              }
            })
            .catch(error => console.error('Error fetching Nav Item Services content:', error));
        
        fetch(process.env.REACT_APP_WP_SERVER + '/wp-json/wp/v2/site_header?slug=nav-item-schedule')
            .then(response => response.json())
            .then(data => {
              if (data[0]?.content?.rendered) {
                setScheduleBtn(data[0].content.rendered);
              }
            })
            .catch(error => console.error('Error fetching Nav Item Schedule content:', error));
    });

  return (
    <div id={styles["eyecatch"]}>
        <div className={styles["test"]}>
            <div className={styles["dog"]}>
                <img src={dogImgUrl} alt="Dog" />
            </div>
            <div className={styles["cta"]}>
                <div className={styles["content"]}>
                    <div dangerouslySetInnerHTML={{ __html: headlineText }}></div>
                    <p className={styles["type"]} dangerouslySetInnerHTML={{ __html: subtitle }}></p>
                    <p className={styles["service"]} dangerouslySetInnerHTML={{ __html: serviceArea }}></p>

                    <div className={styles["btns"]}>
                        <button onClick={test} dangerouslySetInnerHTML={{ __html: servicesBtn }}></button>
                        <button dangerouslySetInnerHTML={{ __html: scheduleBtn }}></button>
                    </div>
                </div>
            </div>
        </div>
    </div>
  );
}

export default Eyecatch;
